import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ptBR from './locales/pt-BR/common.json'
import es from './locales/es/common.json'
import en from './locales/en/common.json'

const resources = {
  'pt-BR': { common: ptBR },
  pt: { common: ptBR },
  es: { common: es },
  en: { common: en },
}

const DEFAULT_LANGUAGE = 'pt-BR'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: ['pt-BR', 'pt', 'es', 'en'],
    ns: ['common'],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  })

export default i18n
